import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PublicAreaModule } from './modules/public-area/public-area.module';
import { AngularCommonModule } from './submodules/angular-common/angular-common.module';
import { AppTranslateModule } from './submodules/angular-common/app-translate.module';
import { AngularUiCommonModule } from './submodules/angular-ui-common/angular-ui-common.module';
import { SecurityUiModule } from './submodules/angular-ui-common/security/security-ui.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,

    // Routes
    AppRoutingModule,

    // i18n
    AppTranslateModule,

    AngularCommonModule,
    AngularUiCommonModule,
    PublicAreaModule,
    SecurityUiModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
